import { composeWithDevTools } from '@redux-devtools/extension';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { cacheExchange, createClient, fetchExchange, Provider as URQLProvider } from 'urql';

import { UrqlGlobalNotice } from '../../shared/components/GlobalNotice';
import sentryExchange from '../../shared/sentryExchange';
import { CurrentPersonProvider } from '../components/CurrentPerson';
import Footer from '../Footer';
import Header from '../Header';
import { reducer } from '../state';
import TaskChoice from './TaskChoice';

const client = createClient({
    exchanges: [cacheExchange, sentryExchange, fetchExchange],
    fetchOptions: {
        credentials: 'same-origin',
        headers: {
            'X-CSRFToken': __CSRF_TOKEN__,
        },
    },
    requestPolicy: 'cache-and-network',
    url: '/graphql/player',
});

export default function init() {
    const store = createStore(
        reducer,
        composeWithDevTools(applyMiddleware(thunk)),
    );

    const container = document.getElementById('task-choice-page');
    Modal.setAppElement(container);
    const root = createRoot(container);
    root.render(
        <URQLProvider value={client}>
            <ReduxProvider store={store}>
                <BrowserRouter>
                    <CurrentPersonProvider>
                        <UrqlGlobalNotice />
                        <Header />
                        <TaskChoice />
                        <Footer />
                    </CurrentPersonProvider>
                </BrowserRouter>
            </ReduxProvider>
        </URQLProvider>,
    );
}
